import React from 'react';
import lightVersion from '../../images/icons/ui-images/light/light-profile.svg';

function ProfileIcon() {

  return (
    <img src={lightVersion} />
  )
}

export default ProfileIcon;
